import { render, staticRenderFns } from "./ContentMedicalInformation.vue?vue&type=template&id=2bdc87f6&"
import script from "./ContentMedicalInformation.vue?vue&type=script&lang=js&"
export * from "./ContentMedicalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports